<template>
  <div>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <div class="title primary--text">{{ section }}</div>
      <v-spacer />
    </div>

    <v-flex xs12 v-if="!linkingProcessStep">
      <v-data-table
        v-if="table.banks.data.length"
        :loading-text="table.banks.title"
        :server-items-length="table.banks.total"
        :loading="table.banks.loading"
        :headers="table.banks.headers"
        :items="table.banks.data"
        :options="table.banks.options"
        :footer-props="{
          'items-per-page-options': [10, 20, 30, 40, 50]
        }"
        sort-by="name"
        @update:options="updateBanksTable"
        class="elevation-1">
        <template v-slot:top>
          <div class="d-flex justify-end py-3">
            <div class="px-3">
              <v-tooltip left v-if="expensesPermissions['create-bank']">
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    fab
                    color="primary"
                    x-small
                    depressed
                    @click="openAddBankDialog(null)"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Agregar banco o caja</span>
              </v-tooltip>
            </div>
          </div>
        </template>
        <template v-slot:[`item.kind`]="{ item }">
          {{ kinds[item.kind] }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <div class="d-flex align-center">
            <v-btn
              v-if="expensesPermissions['update-bank']"
              fab
              color="primary"
              x-small
              depressed
              @click="openAddBankDialog(item)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <div v-if="kinds[item.kind] !== 'Caja' && expensesPermissions['link-bank-account']">
              <v-btn
                v-if="!item.credentialId"
                text
                :plain="true"
                :ripple="false"
                color="primary"
                @click="stepAccountType(item)"
                class="link"
              >
                <v-icon>mdi-settings</v-icon>
                <span class="linkText">Vincular cuenta</span>
              </v-btn>
              <div v-else class="pl-4">
                <v-icon class="linked">mdi-check</v-icon>
                <span class="linked">Cuenta vinculada</span>
              </div>
            </div>
          </div>
        </template>
      </v-data-table>
      <div
        v-else
        class="pa-3 grey lighten-4"
        >
        <div class="d-flex justify-center mt-6">
          <v-row
            align="center"
            justify="center">
            <v-icon
              size="150"
              color="primary">
              mdi-cogs
            </v-icon>
            <v-col cols="4">
              <div class="grey--text">
                <div
                  class="title mb-3 font-weight-bold">
                  Aún no tienes ningún Banco o Caja agregados.
                </div>
                <div class="subtitle-2">
                  <div class="mb-3">
                    Crea aguno para llevar un mejor control de tus ingresos y egresos.
                  </div>
                  <div>
                    <a class="primary--text" href="#" @click="openAddBankDialog(null)" v-if="expensesPermissions['create-bank']">Agregar un banco</a>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-flex>

    <v-flex xs12 v-else-if="linkingProcessStep === 'bankData'">
      <div class="elevation-1 text-center paper mb-1">
        <div
          style="
            max-width: 510px;
            font-size: 34px !important;
            font-weight: bold !important;
            line-height: 40px !important;
            color: #646464 !important;
          "
        >
          {{ $t('expenses.accounts.bankData.title') }}
        </div>
        <img src="@/assets/bankCard.svg" class="my-4" />
        <v-text-field
          autocomplete="off"
          outlined
          rounded
          dense
          v-model.lazy="$v.clientNumber.$model"
          :label="$t('expenses.accounts.bankData.clientNumber')"
          @input="$v.clientNumber.$touch()"
          @blur="$v.clientNumber.$touch()"
          :error-messages="clientNumberErrors"
          class="textField"
          required
        />
        <v-text-field
          autocomplete="off"
          outlined
          rounded
          dense
          type="password"
          v-model.lazy="$v.bancanetKey.$model"
          :label="$t('expenses.accounts.bankData.bancanet')"
          @input="$v.bancanetKey.$touch()"
          @blur="$v.bancanetKey.$touch()"
          :error-messages="bancanetKeyErrors"
          class="textField"
          required
        />
        <v-text-field
          v-if="bank === 8 || bank === 48"
          autocomplete="off"
          outlined
          rounded
          dense
          type="password"
          v-model.lazy="$v.securityCode.$model"
          :label="$t('expenses.accounts.bankData.securityCode')"
          @input="$v.securityCode.$touch()"
          @blur="$v.securityCode.$touch()"
          :error-messages="securityCodeErrors"
          class="textField"
          required
        />
        <div class="text">
          {{ $t('expenses.accounts.bankData.text1') }}
          <a
            href="https://docs.google.com/document/d/1Te9qJSArXl5YExlTpDzEl_sipAAZXC1DSyc5fJ8uP-I/edit"
            target="_blank"
            rel="noopener noreferrer"
            class="link"
            style="color: rgb(15, 111, 255) !important;"
          >
            {{ $t('expenses.accounts.bankData.text2') }}
          </a>
          {{ $t('expenses.accounts.bankData.text3') }}
          <a
            href="https://docs.google.com/document/d/1_OGo4WtJb9H7DpJLZkonIBHBk--Wa_ey2vSGyi2ukuo/edit?usp=sharing"
            target="_blank"
            rel="noopener noreferrer"
            class="link"
            style="color: rgb(15, 111, 255) !important;"
          >
            {{ $t('expenses.accounts.bankData.text4') }}
          </a>
        </div>
        <div class="finerio my-2">
          <div>{{ $t('expenses.accounts.bankData.finerio') }}</div>
          <img src="@/assets/logo-finerio.svg" />
        </div>
        <Button size="small" :disabled="!bancanetKey || !clientNumber || ((bank === 8 || bank === 48) && !securityCode)" @click="stepSuccess">
          {{ $t('expenses.accounts.bankData.button') }}
        </Button>
      </div>
    </v-flex>

    <v-flex xs12 v-else-if="linkingProcessStep === 'success'">
      <div class="elevation-1 text-center paper mb-1 mt-4">
        <div
          style="
            max-width: 400px;
            font-size: 34px !important;
            font-weight: bold !important;
            line-height: 40px !important;
            color: #646464 !important;
          "
        >
          {{ $t('expenses.accounts.success.title') }}
        </div>
        <img src="@/assets/check.svg" class="my-10" />
        <div v-if="accounts.length" class="text-left">
          <div v-for="account in accounts" v-bind:key="account.id">
            {{ account.name }}
          </div>
        </div>
        <div v-else></div>
        <div class="subtext my-8">
          {{ $t('expenses.accounts.success.text') }}
        </div>
        <Button size="x-large" @click="stepEnd" class="mb-10">
          {{ $t('expenses.accounts.success.button') }}
        </Button>
      </div>
    </v-flex>

    <AddBank
      ref="addBank"
      @updated="loadBanks"
    />

    <v-dialog @keydown.esc="accountTypeDialogOpen=false" v-model="accountTypeDialogOpen" max-width="453px" content-class="dialog">
      <v-card>
        <div class="d-flex justify-end">
          <v-btn
            fab
            color="transparent"
            small
            depressed
            @click="closeAccountTypeDialog"
            class="mr-5 mt-5"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-title class="justify-center pt-0">
          <span class="headline">{{ $t('expenses.accounts.accountTypeDialog.title') }}</span>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-radio-group
            v-model="accountType"
            hide-details
            required
          >
            <div class="radio mb-4" :class="{ active: accountType === 'business' }">
              <v-radio
                :label="$t('expenses.accounts.accountTypeDialog.business')"
                value="business"
                color="primary"
                class="radioInput"
              ></v-radio>
              <img src="@/assets/businessAccount.svg" class="accountIcon" :class="{ selectedAccount: accountType === 'business' }" />
            </div>
            <div class="radio" :class="{ active: accountType === 'personal' }">
              <v-radio
                :label="$t('expenses.accounts.accountTypeDialog.personal')"
                value="personal"
                color="primary"
                class="radioInput"
              ></v-radio>
              <img src="@/assets/personalAccount.svg" class="accountIcon" :class="{ selectedAccount: accountType === 'personal' }" />
            </div>
          </v-radio-group>
        </v-card-text>
        <v-card-actions class="justify-center py-8">
          <Button size="small" :disabled="!accountType" @click="stepBank">
            {{ $t('expenses.accounts.bankDialog.button') }}
          </Button>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog @keydown.esc="bankDialogOpen=false" v-model="bankDialogOpen" max-width="400px" content-class="dialog">
      <v-card>
        <div class="d-flex justify-end">
          <v-btn
            fab
            color="transparent"
            small
            depressed
            @click="closeBankDialog"
            class="mr-5 mt-5"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-title class="pt-0">
          <span class="headline">{{ $t('expenses.accounts.bankDialog.title') }}</span>
        </v-card-title>
        <v-card-text class="px-5">
          <Select
            size="fullWidth"
            item-text="name"
            item-value="id"
            :items="banks.data"
            :disabled="!banks.data.length"
            v-model.lazy="bank"
            required
          />
        </v-card-text>
        <v-card-actions class="pt-5 px-5 pb-8">
          <v-spacer></v-spacer>
          <Button size="x-small" :disabled="!bank" @click="stepBankLinking">
            {{ $t('expenses.accounts.bankDialog.button') }}
          </Button>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import AddBank from '@/components/modals/AddBank'
import Button from '@/components/elements/Button'
import Select from '@/components/elements/Select'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import JSEncrypt from 'jsencrypt'

export default {
  name: 'Accounts',
  components: {
    AddBank,
    Button,
    Select
  },
  mixins: [validationMixin],
  validations: {
    clientNumber: { required },
    bancanetKey: { required },
    securityCode: { required }
  },
  data () {
    return {
      overlay: false,
      section: this.$i18n.t('expenses.accounts.section'),
      table: {
        banks: {
          title: this.$i18n.t('expenses.accounts.loading'),
          loading: true,
          headers: [
            { text: this.$i18n.t('expenses.accounts.banks.headers.name'), value: 'name' },
            { text: this.$i18n.t('expenses.accounts.banks.headers.account'), value: 'account.name' },
            { text: this.$i18n.t('expenses.accounts.banks.headers.type'), value: 'kind' },
            { text: this.$i18n.t('expenses.accounts.banks.headers.id'), value: 'number' },
            { text: 'Acciones', value: 'actions' }
          ],
          data: [],
          total: 0,
          options: {
            groupBy: [],
            groupDesc: [],
            itemsPerPage: 50,
            multiSort: false,
            mustSort: false,
            page: 1,
            sortBy: [''],
            sortDesc: []
          }
        },
        accounts: {
          title: this.$i18n.t('expenses.accounts.loading'),
          loading: false,
          headers: [
            { text: this.$i18n.t('expenses.accounts.accounts.headers.name'), value: 'name' },
            { text: 'Acciones', value: 'actions' }
          ],
          data: [],
          total: 0,
          options: {
            groupBy: [],
            groupDesc: [],
            itemsPerPage: 50,
            multiSort: false,
            mustSort: false,
            page: 1,
            sortBy: [''],
            sortDesc: []
          }
        }
      },
      tab: null,
      search: '',
      kinds: {
        bank: 'Banco',
        cash: 'Caja'
      },
      selectedBalanceAccount: null,
      accountTypeDialogOpen: false,
      bankDialogOpen: false,
      accountType: null,
      banks: {
        data: [],
        loading: false
      },
      bank: null,
      linkingProcessStep: null,
      clientNumber: null,
      bancanetKey: null,
      securityCode: null,
      accounts: []
    }
  },
  computed: {
    clientNumberErrors () {
      const errors = []
      if (!this.$v.clientNumber.$dirty) return errors
      !this.$v.clientNumber.required && errors.push(this.$i18n.t('expenses.accounts.bankData.clientNumberErrorsReq'))
      return errors
    },
    bancanetKeyErrors () {
      const errors = []
      if (!this.$v.bancanetKey.$dirty) return errors
      !this.$v.bancanetKey.required && errors.push(this.$i18n.t('expenses.accounts.bankData.bancanetErrorsReq'))
      return errors
    },
    securityCodeErrors () {
      const errors = []
      if (!this.$v.securityCode.$dirty) return errors
      !this.$v.securityCode.required && errors.push(this.$i18n.t('expenses.accounts.bankData.securityCodeErrorsReq'))
      return errors
    },
    expensesPermissions () {
      return this.$store.state.login.permissions['expenses'].components['bank-accounts'].actions
    },
    restaurant () {
      return this.$store.state.currentRestaurant.data
    }
  },
  watch: {
    'search': async function (val) {
      const params = {}
      if (val.length >= 3) {
        try {
          params.q = `/${val}/i`
          await this.load(params)
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
      } else {
        this.load(params)
      }
    },
    restaurant: {
      handler: async function () {
        await this.loadBanks()
      },
      deep: true
    }
  },
  async mounted () {
    await this.loadBanks()
  },
  methods: {
    openAddAccountDialog: function (account) {
      this.$refs.addAccount.openDialog(account)
    },
    openAddBankDialog: function (bank) {
      this.$refs.addBank.openDialog(bank)
    },
    updateBanksTable: async function (data) {
      this.table.banks.options = data
      if (this.$store.state.area) {
        await this.loadBanks({
          restaurant: this.$store.state.currentRestaurant.data._id
        })
      }
    },
    async loadBanks (params = null) {
      params = params || {
        restaurant: this.$store.state.currentRestaurant.data._id
      }
      this.table.banks.loading = true
      try {
        const response = await this.$api.get(`/v1/financial/balance-accounts`, params)
        this.table.banks.data = response
        this.table.banks.total = response.length
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.banks.loading = false
    },
    async loadBanksCatalog (params = null) {
      params = params || {
        type: this.accountType
      }
      this.banks.loading = true
      try {
        const response = await this.$api.get(`/v1/catalog/banks`, params)
        this.banks.data = response
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.banks.loading = false
    },
    updateAccountsTable: async function (data) {
      this.table.accounts.options = data
      if (this.$store.state.area) {
        await this.loadAccounts({})
      }
    },
    async linkBankAccount (params = null) {
      const encrypt = new JSEncrypt()
      encrypt.setPublicKey(process.env.VUE_APP_FINERIO_PUBLIC_KEY)
      params = params || {
        restaurant: this.$store.state.currentRestaurant.data._id,
        balanceAccount: this.selectedBalanceAccount._id,
        bankId: this.bank,
        username: encrypt.encrypt(this.clientNumber),
        password: encrypt.encrypt(this.bancanetKey),
        securityCode: this.securityCode ? encrypt.encrypt(this.securityCode) : undefined
      }
      this.overlay = true
      try {
        const response = await this.$api.post(`/v1/banks/credentials`, params)
        await this.loadBanks()
        await this.loadBankAccounts({ credentialId: response.id })
        this.linkingProcessStep = 'success'
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    async loadBankAccounts (params = null) {
      params = params || {
      }
      this.overlay = true
      try {
        const response = await this.$api.get(`/v1/banks/accounts`, params)
        this.accounts = response.data
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    openAccountTypeDialog () {
      this.resetLinking()
      this.accountTypeDialogOpen = true
    },
    closeAccountTypeDialog () {
      this.accountTypeDialogOpen = false
    },
    openBankDialog () {
      this.bankDialogOpen = true
    },
    closeBankDialog () {
      this.bankDialogOpen = false
    },
    stepAccountType (item) {
      this.selectedBalanceAccount = item
      this.openAccountTypeDialog()
    },
    stepBank () {
      this.closeAccountTypeDialog()
      this.loadBanksCatalog()
      this.openBankDialog()
    },
    stepBankLinking () {
      this.closeBankDialog()
      this.linkingProcessStep = 'bankData'
    },
    stepSuccess () {
      this.linkBankAccount()
    },
    stepEnd () {
      this.linkingProcessStep = null
    },
    resetLinking () {
      this.accountType = null
      this.bank = null
      this.clientNumber = null
      this.bancanetKey = null
      this.securityCode = null
      this.$v.$reset()
    }
  }
}
</script>

<style lang="scss" scoped>
  .link {
    text-transform: none;
    &:hover::before {
      background-color: transparent !important;
    }
    &:hover {
      .linkText {
        text-decoration: underline;
      }
    }
  }

  .dialog {
    border-radius: 22px !important;
  }

  .headline {
    font-size: 22px;
    font-weight: 500;
    color: #01D28E;
    line-height: 26px;
  }

  .radio {
    padding: 7px 10px 7px 20px;
    border: 2px solid transparent;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.07);
    border-radius: 14px;

  }

  .active {
    border: 2px solid #01D28E;
    box-shadow: none;
  }

  .radioInput {
    margin-top: 11px;
    position: absolute;
  }

  .accountIcon {
    width: 230px;
    margin-left: 130px;
    opacity: 0.5
  }

  .selectedAccount {
    opacity: 1
  }

  .paper {
    display: flex;
    padding-top: 40px;
    padding-bottom: 50px;
    border-radius: 26px;
    background-color: #fff;
    flex-direction: column;
    align-items: center;
  }

  .img {
    max-width: 284px;
  }

  .textField {
    width: 284px;
  }

  .text {
    width: 284px;
    font-size: 12px;
    line-height: 14px;
  }

  .link {
    text-decoration: none;
  }

  .linked {
    color: #0F6FFF !important;
  }

  .finerio {
    font-size: 12px;
    color: #646464;
  }

  .subtext {
    width: 300px;
    font-size: 16px;
    line-height: 19px;
    color: #ACABAB;
  }

</style>
